
import { ChevronRight, Home } from "lucide-react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

const DashboardBreadcrumb = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  // Format segment for better display
  const formatSegment = (segment: string, index: number): string => {
    // Handle special cases and formatting
    const formatted = segment
      .replace(/-/g, ' ')  // Convert dashes to spaces
      .replace(/([A-Z])/g, ' $1')  // Add spaces before capital letters
      .trim();

    // Check if it's a UUID - if so, just call it "Details"
    const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (uuidPattern.test(segment)) {
      return "Details";
    }
    
    // Capitalize first letter
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  };

  return (
    <div className="flex items-center gap-2 text-sm text-slate-600">
      <Link to="/dashboard" className="flex items-center gap-1 hover:text-slate-900">
        <Home size={16} />
        <span>Home</span>
      </Link>
      {pathSegments.map((segment, index) => (
        <div key={segment} className="flex items-center gap-2">
          <ChevronRight size={16} className="text-slate-400" />
          {index < pathSegments.length - 1 ? (
            <Link 
              to={`/${pathSegments.slice(0, index + 1).join('/')}`}
              className="hover:text-slate-900"
            >
              {formatSegment(segment, index)}
            </Link>
          ) : (
            <span className="font-medium text-slate-900">
              {formatSegment(segment, index)}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default DashboardBreadcrumb;
